<template>
    <div class="block-container">
      <div class="board">
        <div class="page page-resultados padding-lr">
          <div class="search-term">{{ tag }}</div>
        </div>
        <section class="section padding-b" v-if="news.length">
          <article-two v-for="item in news" :key="item.id" :news="item" :cssClass="cssClass"></article-two>
        </section>
      </div>
      <div class="pagination" v-if="pagination.total_pages > 1">
        <div class="pagebutton pageprev" v-if="pagination.current_page > 1"><a @click="goPage(-1)" style="cursor: pointer">« Anterior</a></div>
        <div class="allpages">
          <ul>
            <li v-for="index in pagination.pages" :key="index"><a @click="goPage(index)" style="cursor: pointer">{{index}}</a></li>
          </ul>
        </div>
        <div class="pagebutton pagenext" v-if="pagination.current_page < pagination.total_pages"><a @click="goPage(1)" style="cursor: pointer">Siguiente »</a></div>
      </div>
    </div>
</template>

<script>
import _Page         from "@core/vuejs/templates/mixins/_Page"
import Lazyload     from '@core/assets/js/modules/lazyload'
import _SSRPath from "@core/vuejs/templates/mixins/_SSRPath.vue";

export default {
  name: "TagPage",
  mixins: [_Page, _SSRPath],
  data: function() {
    return {
      title: 'Tags Page',
      endpoint: '/news/tags/',
      limit: 24,
      activeRequest: false,
      error: false,
      started: false,
      tag: '',
    };
  },
  mounted() {
    this.getNews(this.currentPage())
  },
  computed: {
    news: function () { return this.$store.getters['lastnews/news'](this.pagination.current_page) || false },
    pagination: function () { return this.$store.getters["lastnews/pagination"] || [] },
    cssClass: function() { return this.activeRequest ? 'active-request' : ''}
  },
  updated() {
    if ('undefined' === typeof document) return false
    let title = this.tag + ' | iProUP',
        description = 'Información imprescindible para las finanzas personales. Economía, impuestos, tecnología y buenos negocios. Cómo cuidar tu dinero.'

    title = title + ((1 === this.pagination.current_page) ? '' : ' | Página ' + this.pagination.current_page)
    description = (1 === this.pagination.current_page) ? description
        : 'Información imprescindible para las finanzas personales. Economía, impuestos, tecnología y buenos negocios. Cómo cuidar tu dinero. | Página ' + this.pagination.current_page

    document.querySelector('title').textContent = title
    document.querySelector('meta[name="description"]').textContent = description
  },
  beforeMount() {
    if (window._page) this.$store.commit('section/page', window._page)

    this.tag = this.getTag();

    let Store = this.$store
    Store.commit('lastnews/setNews', {
      current_page: window._page.content.current_page,
      news: window._page.content.data.News
    })
    Store.commit('lastnews/setPagination', {
      'current_page': window._page.content.current_page,
      'total_items': window._page.content.total_items,
      'total_pages': window._page.content.total_pages
    })
  },
  methods: {
    currentPage: function () {
      let page = 1;
      let path = '';

      if (typeof window !== 'undefined') {
        path = window.location.pathname;
      } else {
        path = this.getCurrentPath();
      }

      const segments = path.split('/').filter(Boolean); // elimina segmentos vacíos
      const lastSegment = segments[segments.length - 1];

      if (!isNaN(lastSegment) && parseInt(lastSegment) > 1) {
        page = parseInt(lastSegment);
      }

      return page;
    },
    goPage: function(value) {
      const next_page = this.pagination.current_page + value;
      const basePath = `/tags/${this.tag.toLowerCase().replace(/\s+/g, '-')}`;

      const newPath = (next_page > 1) ? `${basePath}/${next_page}` : basePath;

      if (typeof window !== 'undefined') {
        window.history.pushState({}, '', newPath);
      }

      this.getNews(next_page);
    },
    prefetch: function() {
      const next_page = this.pagination.current_page + 1;

      // Obtener la URL actual (solo funciona en cliente)
      const currentUrl = window.location.pathname;
      const searchParams = new URLSearchParams(window.location.search);

      // Setear el nuevo valor de "page"
      if (next_page !== 1) {
        searchParams.set('page', next_page);
      } else {
        searchParams.delete('page');
      }

      const newPath = `${currentUrl}?${searchParams.toString()}`;

      // Hacer la petición
      this.$http.Get({ url: newPath, progressbar: false });
    },
    getNews: function(next_page = 1) {
      let Store = this.$store;

      window.scroll({top: 0, behavior: "smooth"});

      if (!Store.getters['lastnews/hasNews'](next_page))
      {
        this.activeRequest = true;

        this.$client.Get(this.endpoint+this.tag.toLowerCase(), {
          apiBase: this.$settings.api.url,
          datafull: true,
          progressbar: true,
          query: {
            page: next_page,
            limit: this.limit,
            rnd: window._page.updated
          },
          callback: response => {
            Store.commit('lastnews/setNews', {
              current_page: response.current_page,
              news: response.data.news
            })
            Store.commit('lastnews/setPagination', {
              'current_page': response.current_page,
              'total_items': response.total_items,
              'total_pages': response.total_pages
            })

            setTimeout(function() {
              Lazyload.start()
            }, 500);
            this.activeRequest  = false
            this.started        = true
          },
          onError: error => {
            this.error = true
          }
        });
      }else{
        this.$store.commit('lastnews/currentPage', next_page)
        window.scroll({top: 0, behavior: "smooth"});
      }
    },
    getTag: function() {
      let path = '';

      if (typeof window !== 'undefined') {
        path = window.location.pathname;
      } else {
        path = this.getCurrentPath().split('?')[0];
      }

      const segments = path.split('/').filter(Boolean);
      const tagRaw = segments[1] || '';

      const tag = tagRaw.replace(/-/g, ' ');
      return tag.charAt(0).toUpperCase() + tag.slice(1);
    },
    item: function(index) {
      return this.news[index] || false;
    },
  }
}
</script>

<style scoped>
.article-item.active-request {
  animation: item-active-request 1s; animation-iteration-count: infinite;
}

@keyframes item-active-request {
  0% { opacity: 90%; }
  50% { opacity: 45%; }
  100% { opacity: 90%; }
}
</style>